import script from "./ToolPageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolPageHeader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__